export enum VatType {
   PrivatePerson = 1,
   NotApplicable = 2,
   NormalVat = 4
}
